export enum AuthError {
  AccountNotVerified = 'accountNotVerified',
  DociaRegistrationsNotReleased = 'dociaRegistrationsNotReleased',
  EmailNotConfirmed = 'emailNotConfirmed',
  FacebookSsoMethodNotLinked = 'facebookSsoMethodNotLinked',
  GoogleSsoMethodNotLinked = 'googleSsoMethodNotLinked',
  InvalidCredentials = 'invalidCredentials',
  InvalidSsoToken = 'invalidSsoToken',
  MissingPlatform = 'missingPlatform',
  MultipleSignInMethods = 'multipleSignInMethods',
  NoMethodWithEmailProvided = 'noMethodWithEmailProvided',
  SignInMethodConflict = 'signInMethodConflict',
  SsoCandidateNotFound = 'ssoCandidateNotFound',
  NoJobTitlesProvided = 'No job titles provided',
  WrongPlatformForSourceDomain = 'wrongPlatformForSourceDomain',
}
